module.exports = __webpack_public_path__ + "static/media/8x10no3.5120d317.jpg";